import { intl } from 'lang/intl'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import AspectContainer from '../../../../components/AspectContainer/AspectContainer'
import Button from '../../../../components/ButtonComponent/ButtonComponent'
import { useWebinarColors } from '../../../../../Designs/blocs/useWebinarColors'
import { WebinarPanelComponent } from '../index'

import './DigitalEventCard.scss'

interface DigitalEventCardProps {
  title: string
  thumbnailUrl: string
  numberOfSessions: number
  numberOfLiveSessions?: number
  onClick?: () => void
}

const DigitalEventCard = ({
  title,
  thumbnailUrl,
  numberOfSessions,
  numberOfLiveSessions,
  onClick = () => {},
}: DigitalEventCardProps) => {
  const webinarColors = useWebinarColors()

  return (
    <WebinarPanelComponent>
      <div className="content-enclosure">
        <div className="thumbnail">
          <AspectContainer>
            <img
              src={thumbnailUrl}
              alt={intl.formatMessage({
                defaultMessage: 'Thumbnail for session',
              })}
            />
          </AspectContainer>
        </div>
        <div className="info-enclosure">
          <div className="title">{title}</div>
          <div className="count">
            <FormattedMessage
              defaultMessage="{sessionCount, plural,
                zero {No sessions}
                one {# session}
                other {# sessions}
              }"
              values={{ sessionCount: numberOfSessions }}
            />
            {!!numberOfLiveSessions && numberOfLiveSessions > 0 && (
              <>
                {' — '}
                <FormattedMessage
                  defaultMessage="{count} live"
                  values={{ count: numberOfLiveSessions }}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <Button
        type="button"
        style={{
          backgroundColor: webinarColors.accent,
          color: webinarColors.accent.highContrast,
          borderColor: 'transparent',
        }}
        onClick={onClick}
        round
      >
        <FormattedMessage defaultMessage="See sessions" />
      </Button>
    </WebinarPanelComponent>
  )
}

export default DigitalEventCard
